import React from 'react';
import './GeneralHelp.css';

const GeneralHelpComponent = () => {
  return (
    <div className="container-1024">
      <div className="help-area">
        <h3>Help Center</h3>
        <div className="help-content">
          <div className="help-center-details">
            <div className="help-section">
              <h4>General Information</h4>
              <p>
                <span>Q. Why should I try online dating with KissDateLove.com?</span> <br/>
                A. Everyone is unique, and online dating lets you refine your search to find your perfect match. Many of our members choose KissDateLove.com instead of the traditional bar scene or other dating methods. Some join just for fun, while others are seriously looking for connection. Best of all, our basic service is FREE! You can search for potential matches in your neighborhood or worldwide—it's entirely up to you. Before reaching out to someone, you can view their photo and read their profile to get a sense of who they are. Forget the hassle of the bar scene and look for your partner whenever and wherever you want with KissDateLove.com.
              </p>
            </div>

            <div className="help-section">
              <h4>Does online dating actually work?</h4>
              <p>
                Online dating is one of the most successful innovations to emerge from the Internet age. KissDateLove.com is part of a global community with millions of members worldwide, with thousands of new singles joining daily! The sheer number of people finding connections through online dating platforms like ours demonstrates its effectiveness—otherwise, why would so many people continue to join?
              </p>
            </div>

            <div className="help-section">
              <h4>Is online dating safe?</h4>
              <p>
                Online dating through KissDateLove.com is no more or less safe than traditional dating methods. Our platform is designed with your safety in mind, but we recommend following these basic precautions:
              </p>
              <ul className="help-list">
                <li>Know how to contact our customer support team if you have questions about our service</li>
                <li>Never share your password or other private information with other members under any circumstances</li>
                <li>Remember that KissDateLove.com staff will never ask for your password</li>
                <li>Avoid revealing personal details like your real name, phone number, credit card information, home address, or email address in chat rooms, as you never know who might be viewing</li>
                <li>Consider using an anonymous email account for dating communications</li>
              </ul>
            </div>

            <div className="help-section">
              <h4>What are my chances of meeting someone special on KissDateLove.com?</h4>
              <p>
                Just like with traditional matchmaking, your chances of meeting someone compatible depend on the quality of the matching process. At KissDateLove.com, our sophisticated matching system makes finding meaningful connections significantly easier than random encounters. While there's always an element of chance in any dating scenario, our platform is designed to maximize your opportunities for successful matches.
              </p>
            </div>

            <div className="help-section">
              <h4>How much does membership cost?</h4>
              <p>
                Basic membership at KissDateLove.com is completely FREE and includes the ability to send emails to other members.
              </p>
            </div>

            <div className="help-section">
              <h4>When can I start contacting other members?</h4>
              <p>
                You can begin emailing other members, whether initiating conversations or replying to messages, as soon as you complete your free registration with KissDateLove.com.
              </p>
            </div>

            <div className="help-section">
              <h4>How do I maintain my privacy?</h4>
              <p>
                What happens at KissDateLove.com stays at KissDateLove.com. We use a secure double-blind email system to protect your privacy. This system replaces your actual email address with your username and our domain (e.g., GolfGuy1@KissDateLove.com) and then forwards messages to the members you're communicating with.
              </p>
            </div>

            <div className="help-section">
              <h4>Managing Your Profile</h4>
              <p>
                <span>Edit Your Profile</span> <br/>
                Your profile contains questions about who you are, your interests, lifestyle, background, values, and what you're looking for in a match. This information helps create a comprehensive picture of you and your ideal partner. Not only does this help potential matches understand you better, but it also enables our unique matching tools to provide you with more compatible connections.
              </p>
            </div>

            <div className="help-section">
              <h4>Profile Tips</h4>
              <p>
                No one likes a boring profile. Have fun with it and be creative! Need inspiration? View our Sample Topics for ideas about what to include in your personal description.
              </p>
            </div>

            <div className="help-section">
              <h4>Editing Your Profile</h4>
              <p>
                You can update your profile anytime—simply click "Edit Profile" and select the pencil icon located on the right side of each section to make changes.
              </p>
              <p>
                You can save portions of your profile and return to them later. Just remember that nothing is published until the "Summary" section is complete and approved. When working on written sections, be aware that typing for more than 45 minutes risks a session time-out, which could result in lost data.
              </p>
              <p>
                In some sections, you'll have the option to make certain preferences a "Must-Have" in the "What I'm Looking For" portion of your profile. Click "Done" to save your changes.
              </p>
              <p>
                If you're editing a field that requires approval, it may take up to 24 hours before it's approved and visible on the site.
              </p>
            </div>

            <div className="help-section">
              <h4>Visibility</h4>
              <p>
                Your profile automatically becomes visible after changes are approved. If you don't want your profile to be visible after editing, you'll need to hide it as soon as it's approved. You can hide your profile through your Profile Settings.
              </p>
            </div>

            <div className="help-section">
              <h4>Profile Completion Requirements</h4>
              <p>
                You don't need to complete your entire profile to start using KissDateLove.com. As soon as you create an account, you can begin searching and connecting with other members right away.
              </p>
              <p>
                Members with paid subscriptions can send and receive messages even with a hidden, incomplete, or pending profile. However, some free communication features, such as sending Likes, require you to have at least one photo uploaded to your profile.
              </p>
            </div>

            <div className="help-section">
              <h4>Troubleshooting Profile Editing Issues</h4>
              <p>
                If you're having trouble editing your profile, consider these possible explanations:
              </p>
              <ul className="help-list">
                <li>Your profile appears normal to everyone else and will appear normal to you once you clear your cache and cookies</li>
                <li>Your profile is currently hidden</li>
                <li>You haven't completed required profile sections</li>
                <li>You experienced a session time-out after typing profile text for longer than 45 minutes</li>
                <li>Your profile was submitted but not approved</li>
              </ul>
            </div>

            <div className="help-section">
              <h4>Content Guidelines</h4>
              <p>
                We may reject profiles containing any of the following:
              </p>
              <ul className="help-list">
                <li>Abusive language, including profanity, vulgarity, racism, references to illegal activity, etc.</li>
                <li>Direct contact information (email addresses, URLs, messenger IDs, phone numbers, physical addresses)</li>
                <li>Unauthorized use of copyrighted or trademarked material</li>
                <li>Business or political advertisements or solicitations</li>
                <li>References to illegal activities or drug use</li>
                <li>Languages other than English, Spanish, or French</li>
                <li>Material that exploits or solicits information from individuals under 18</li>
                <li>Explicit sexual content, solicitation, or descriptions of sexual activity</li>
                <li>Solicitation of multiple or additional partners</li>
                <li>Insufficient or illegible content</li>
              </ul>
              <p>
                KissDateLove.com does not accept content from:
              </p>
              <ul className="help-list">
                <li>Incarcerated individuals</li>
                <li>Individuals under 18 years of age</li>
              </ul>
            </div>

            <div className="help-section">
              <h4>Profile Approval Process</h4>
              <p>
                When you update your profile text, our team reviews it before it appears on the site. This process typically takes some time for system to sync, and we'll notify you by email once your profile has been reviewed and approved.
              </p>
              <p>
                We review all sections of your profile, including the main profile essay, responses to other profile questions, first name, occupation, etc. Whenever you make an update, the new text is reviewed before becoming visible to other members.
              </p>
              <p>
                <strong>Pending Approval</strong><br/>
                When you submit a profile update, it enters "Pending" status while awaiting review. Your previous approved profile text will remain visible during this time, unless you don't have any previously approved content.
              </p>
              <p>
                <strong>Profile Approved</strong><br/>
                If your profile is Hidden, it will automatically become Visible when your updated profile is approved.
              </p>
              <p>
                If you're using Private Mode, your profile will not automatically become Visible when an update is approved. To keep your profile Hidden, you'll need to adjust your visibility settings again after your profile update is approved.
              </p>
              <p>
                <strong>Profile Rejected</strong><br/>
                If your new profile text doesn't meet our guidelines, it won't be approved or displayed. We'll email you explaining why. In most cases, your previously approved profile text will remain visible. Sometimes, a profile rejection may cause your profile to become hidden.
              </p>
            </div>

            <div className="help-section">
              <h4>Hiding Your Profile</h4>
              <p>
                There may be times, such as when you begin a new relationship, when you'll want to remove your profile from view. When hidden, your profile won't appear in search results, and you'll be "incognito."
              </p>
              <p>
                Since hiding reduces your chances of finding matches, we recommend only using this feature when taking a break or when you've met someone you're interested in pursuing.
              </p>
              <p>
                As a KissDateLove.com member, you can hide your profile at any time, for any reason.
              </p>
              <p>
                <strong>Can others see my hidden profile?</strong><br/>
                When you hide your profile, it's no longer visible on the site, won't appear in search results, and won't be accessible to previous connections.
              </p>
              <p>
                If you previously communicated with another member, they will still be able to read and reply to your messages, but your profile won't be accessible and will appear as "Profile Unavailable" in the message thread.
              </p>
              <p>
                <strong>Adjusting Visibility</strong><br/>
                Click your photo thumbnail in the header and select your visibility preference. You can choose to allow anyone to view your profile or hide it completely.
              </p>
              <p>
                If you view another member's profile while yours is hidden, our system still registers your visit. Once you unhide your profile, it will appear in their "Who's Viewed Me" section, but not before then.
              </p>
              <p>
                You may notice your profile counter continues to increase while your profile is hidden. This happens when members who know your username attempt to view your unavailable profile.
              </p>
              <p>
                <strong>Need Help?</strong> Log into your account click Contact Us in the footer. We look forward to any questions or feedback.
              </p>
            </div>

            <div className="help-section">
              <h4>Controlling Who Sees Your Profile and Photos</h4>
              <p>
                While you can adjust your overall profile visibility anytime, we don't currently offer a feature that allows you to selectively hide or make your profile visible to specific members. Here are alternative options:
              </p>
              <p>
                <strong>Blocking/Unblocking</strong><br/>
                You can block another member from accessing your profile by clicking the Block button on their profile. To block someone, navigate to their profile, click the 3-dot icon, then click Block.
              </p>
              <p>
                To unblock someone, click the gear icon at the top of your screen, then click Settings. Next, click the Blocking link. Select the member you wish to unblock, then click Unblock at the bottom of the page.
              </p>
              <p>
                <strong>Private Mode</strong><br/>
                On your main profile page, you'll see a setting labeled "Choose who sees you." Select this option to control your visibility:
              </p>
              <ul className="help-list">
                <li>Like or message someone to unlock your profile for their eyes only. You can lock it again anytime.</li>
                <li>Turn it off whenever you don't want to use it.</li>
                <li>Track who sees your profile. The Private Mode shield on a person's profile keeps track of who can see you. Press the icon to re-lock your profile anytime.</li>
              </ul>
            </div>

            <div className="help-section">
              <h4>Removing Profiles From Search Results</h4>
              <p>
                <strong>How to Do It</strong><br/>
                Visit the member's profile page and click "Remove from search." That member will no longer appear in your search results or other lists. They won't know you've taken this action.
              </p>
              <p>
                <strong>Restoring Removed Profiles - on Desktop</strong><br/>
                To view your list of removed profiles, access your Account Settings page. Click the gear icon in the main menu at the top of any page, then select "Settings" from the dropdown menu. On the Account Settings page, click "Removed Profiles." To give a member another chance, mark the checkbox next to their username and click the "Show" button at the bottom of the list.
              </p>
            </div>

            <div className="help-section">
              <h4>Session Timing Out</h4>
              <p>
                At KissDateLove.com, we take security seriously. Our "session time-out" feature automatically signs you out if you've been on the same screen for more than standard system time. This ensures that if you sign in and later step away from your computer, no one else can access your account.
              </p>
              <p>
                This requires caution when filling in profile text or typing messages, as a session time-out could result in losing your work. When working on profile text, consider composing in a word processing application where you can save your progress, then copy and paste the completed text into the KissDateLove.com text field.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralHelpComponent;